export enum ExternalApplicationOPEEnum {
  PutExternalApplication = 'putExternalApplication',
  GetExternalApplication = 'getExternalApplication',
  GetExternalApplicationApiCallsLog = 'getExternalApplicationApiCallsLog',
  ChangeExternalApplicationSecret = 'changeExternalApplicationSecret',
  DelExternalApplication = 'delExternalApplication',
  UpdateExternalApplicationPartition = 'updateExternalApplicationPartition',
}
